import { useNavigate } from 'react-router-dom';
import { RollbackOutlined } from '@ant-design/icons';

import { Button, Card, Grid, Row, Typography } from '@Shared/ui';

import { BarterForm } from './barterForm';

const { Title } = Typography;
const { useBreakpoint } = Grid;

const BarterFormCard = () => {
    const navigate = useNavigate();
    const breakpoints = useBreakpoint();

    return (
        <Card>
            <Row
                align="top"
                style={{ columnGap: 16, rowGap: 24 }}
                wrap={false}
            >
                <Title
                    level={3}
                    style={{ marginTop: 4 }}
                >
                    Настройка рекламной кампании - Бартер
                </Title>
                <Button
                    icon={<RollbackOutlined />}
                    iconPosition="end"
                    type="link"
                    onClick={() => navigate(-1)}
                >
                    {breakpoints.lg ? 'Назад' : ''}
                </Button>
            </Row>
            <BarterForm />
        </Card>
    );
};

export default BarterFormCard;
